import React, { useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { axiosInstance } from '../../../../api/strapi';
import Loader from '../../../../ui-core/Loader';

const OldProdcast = () => {
  const params = useParams();
  const history = useHistory();

  const fetchData = async () => {
    try {
      const endpoint = `/podcasts?filters[episode][$eq]=${params?.name}&sort=episode:DESC`;
      const response = await axiosInstance.get(endpoint);
      if (response?.data?.data?.length > 0) {
        const responseData = response?.data?.data[0];
        history.push(
          `/podcast/${
            responseData?.attributes?.episode
          }/${responseData?.attributes?.title
            ?.toLowerCase()
            ?.trim()
            ?.split(' ')
            ?.join('-')}`,
        );
      }
    } catch (error) {}
  };

  useEffect(() => {
    fetchData();
  }, []);
  return <Loader isLoading={true} />;
};

export default OldProdcast;
